import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Real config for the `hec-console` Firebase project -- NOT `hec-catalog`.
// The two were deliberately split 2026-09-29: `hec-catalog` is the data
// plane (products/corpus), `hec-console` is the serving/app plane
// (this console's own Cloud Run, Hosting, and Auth). console_principals
// lives here too, in hec-console's own Firestore -- it's access-control data
// for this app, not corpus data. See ops/CONSOLE_AUTH_SCOPE.md.
//
// The apiKey here is a public, client-embeddable identifier (standard
// Firebase practice, NOT a secret; security comes from Firebase Auth + the
// server's own token verification in backend/api/main.py, not from hiding this
// value). Matches DLA BUS's own console pattern.
const firebaseConfig = {
  apiKey: "AIzaSyCdrTnBVXGTkqqztS1QmLPoo7f4KPe6z-I",
  authDomain: "hec-console-158d4.firebaseapp.com",
  projectId: "hec-console",
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
